export const isViewportSufficient = (viewport: $TSFixMe, widthBreakpoint: $TSFixMe, height: $TSFixMe) =>
    viewport.width > widthBreakpoint.high && viewport.height > height;
